import { config } from '@uhg-abyss/web/tools/config';

export const enableDevTools = () => {
  const ABYSS_DEVTOOLS = config('ABYSS_DEVTOOLS');

  if (ABYSS_DEVTOOLS === false) {
    return false;
  }

  return ABYSS_DEVTOOLS;
};
